import React from 'react'
import { noTagColor } from '../util/tag_utils'
import TeamSigil from './team_sigil'

const Tag = (tag, teams) => {
    const { name, color } = tag
    const sigil = TeamSigil(teams[tag.teamId], tag.teamSigil)
    return (
        <div className="tag">
            {sigil}
            <span style={{ backgroundColor: color }} className="caption">{name}</span>
        </div>
    )
}

const PersonalTag = (tag) => {
    return (
        <div className="tag">
            <span style={{backgroundColor: tag.color}} className="caption">{tag.name}</span>
        </div>
    )
}

const CompoundTags = (team, tags) => {
    if (team.isPersonal) {
        return tags.map( (t, i) => PersonalTag(t) )
    }

    const teamSigil = TeamSigil(team)
    return (
        <div className="tag" key={team.id}>
            {teamSigil}
            {tags.map( (t, i) => (<span key={`${team.id}-${t.id}-${i}`} style={{backgroundColor: t.color}} className="caption">{t.name}</span>))}
        </div>
    )
}

const NoTags = () => <Tag name="No Tags" color={noTagColor} />

export {
    Tag as default,
    NoTags,
    CompoundTags,
}


// WEBPACK FOOTER //
// ./src/components/tag.jsx